var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":function($event){return _vm.clicked()}}},[_c('text-content',{attrs:{"weight":'medium',"lineHeight":'multi',"size":'sm2'}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }